import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType, GenericColumnData } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import Modal from "components/Modal/Modal";
import { roles } from "utils/constant";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { Button } from "@heroui/react";
import { useAuthStore } from "store/auth";

const CompanyExpensesList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [kpsTotal, setKpsTotal] = useState<any>({});
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").endOf("month").format("YYYY-MM-DD"));
  const [sortStat, setSortStat] = useState<any>({});
  const [addModalOpen, setAddModalOpen] = useState(false);

  // Multi-select state (payment features similar to Vendor Payment)
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [gstTdsPaidModalOpen, setGstTdsPaidModalOpen] = useState(false);
  const [paidType, setPaidType] = useState<"gst" | "tds" | null>(null);
  const [isPaidAction, setIsPaidAction] = useState<boolean>(true); // true = mark as paid, false = mark as unpaid
  const [bulkActionModalOpen, setBulkActionModalOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState<"disburse" | "reject" | null>(null);
  const [bulkRemark, setBulkRemark] = useState("");

  const [query, setQuery] = useState<any>({
    billDate: {
      $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
      $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
    },
  });
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [branchOpt, setBranchOtp] = useState<any>();
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [cityOptions, setCityOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [selectedCity, setSelectedCity] = useState<any>();

  const [selectedStatus, setSelectedStatus] = useState<any>();

  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const [seletedPayment, setSeletedPayment] = useState<any>({});
  const [disburseModalOpen, setDisburseModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const [refNo, setRefNo] = useState<any>("");
  const [payDate, setpayDate] = useState<any>("");
  const [payType, setPayType] = useState<any>({});

  const [selectedHead, setSelectedHead] = useState<any>();
  const [expenseHeadOptions, setExpenseHeadOptions] = useState<any>(
    GenericColumnData?.companyexpense?.tableColumnData?.find((d: any) => d.key === "head")?.options || []
  );

  useQuery(["VendorListApi"], () => ListCommanWay("/admin/vendor/list", { vendorType: "Rental" }, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.vendor_name,
          });
        });
        setBranchOptions(opt);
      }
    },
  });
  useQuery(["CityListApi"], () => ListCommanWay("/admin/city/list", {}, { paginate: 100000 }), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        if (data?.data) {
          Object.values(data?.data?.data)?.forEach((d: any) => {
            opt.push({
              value: d?.id,
              label: d?.city_name,
            });
          });
          setCityOptions(opt);
        }
      }
    },
  });

  const {
    mutate: deleteCompanyExpense,
    isLoading: isDeleting,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((id) => CreateCommanWay({ url: "/admin/companyexpense/deleteMany", data: { isWarning: true, ids: [id] } }), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        setTotals({ grand: 0 });
        UseToast("Payment Removed Successfully", "success");
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: updatePayMutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        setTotals({ grand: 0 });
        refetch();
        setDisburseModalOpen(false);
        setVerifyModalOpen(false);
        setRejectModalOpen(false);
        setGstTdsPaidModalOpen(false);
        setSelectedRows(new Set());
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  // Bulk update mutation for GST/TDS paid & bulk disburse/reject
  const { mutate: bulkUpdatePayMutate, isLoading: isBulkUpdating } = useMutation(
    (params: { ids: number[]; updateData: any }) =>
      UpdateCommanWay({
        url: "/admin/companyexpense/updateBulk",
        data: {
          filter: { id: params.ids },
          data: params.updateData,
        },
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          UseToast("Data Updated Successfully", "success");
          setTotals({ grand: 0 });
          refetch();
          setGstTdsPaidModalOpen(false);
          setBulkActionModalOpen(false);
          setBulkActionType(null);
          setBulkRemark("");
          setSelectedRows(new Set());
          setPaidType(null);
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    },
  );

  // Calculate total for selected rows
  const getSelectedTotal = (type: "gst" | "tds") => {
    let total = 0;
    tableData.forEach((row: any) => {
      if (selectedRows.has(row.id)) {
        if (type === "gst") {
          total += Number(row.cgst || 0) + Number(row.sgst || 0) + Number(row.igst || 0);
        } else {
          total += Number(row.tds || 0);
        }
      }
    });
    return total;
  };

  // Handle select all
  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = tableData.map((row: any) => row.id);
      setSelectedRows(new Set(allIds));
    } else {
      setSelectedRows(new Set());
    }
  };

  // Handle single row select
  const handleRowSelect = (id: number, checked: boolean) => {
    const newSelected = new Set(selectedRows);
    if (checked) {
      newSelected.add(id);
    } else {
      newSelected.delete(id);
    }
    setSelectedRows(newSelected);
  };

  // Handle paid button click
  const handlePaidClick = (type: "gst" | "tds", markAsPaid: boolean = true) => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setPaidType(type);
    setIsPaidAction(markAsPaid);
    setGstTdsPaidModalOpen(true);
  };

  // Handle confirm paid
  const handleConfirmPaid = () => {
    if (!paidType || selectedRows.size === 0) return;

    const ids = Array.from(selectedRows);
    const updateData = paidType === "gst" ? { gstPaid: isPaidAction } : { tdsPaid: isPaidAction };

    bulkUpdatePayMutate({ ids, updateData });
  };

  // Handle bulk disburse/reject
  const handleBulkAction = (type: "disburse" | "reject") => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setBulkActionType(type);
    setBulkRemark("");
    setBulkActionModalOpen(true);
  };

  const handleConfirmBulkAction = () => {
    if (!bulkActionType || selectedRows.size === 0) return;
    const ids = Array.from(selectedRows);
    const updateData =
      bulkActionType === "disburse"
        ? { payStatus: "PAID" }
        : { payStatus: "REJECTED", remark: bulkRemark };
    bulkUpdatePayMutate({ ids, updateData });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_companyexpenses_report_list"],
    () => ListCommanWay("/admin/companyexpense/list", { ...query }, { paginate: 1000, include: ["_vendor"] }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          setSortStat({});

          let ary = [...data.data.data];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,
            tds: 0,
            paid: 0,
            payable: 0,
            totalPaid: 0,
            remaining: 0,
          };

          let kps = {};
          ary.forEach((a) => {
            //console.log(a.base_value);
            ttt.base += Number(a.amount || 0);
            ttt.cgst += Number(a.cgst) || 0;
            ttt.sgst += Number(a.sgst) || 0;
            ttt.igst += Number(a.igst) || 0;
            ttt.utgst += Number(a.utgst || 0) || 0;
            ttt.grand += Number(a.finalTotal) || 0;
            ttt.tds += Number(a.tds) || 0;
            ttt.paid += (Number(a.finalTotal) || 0) - (Number(a.tds) || 0);
            ttt.payable += (Number(a.finalTotal) || 0) - (Number(a.tds) || 0);
            ttt.totalPaid += Number(a.totalPaid) || 0;
            ttt.remaining += ((Number(a.finalTotal) || 0) - (Number(a.tds) || 0)) - (Number(a.totalPaid) || 0);

            if (!kps[a.payStatus]) {
              kps[a.payStatus] = [0, 0, 0];
            }
            kps[a.payStatus][0]++;
            kps[a.payStatus][1] += Number(a.finalTotal) || 0;
            kps[a.payStatus][2] += Number(a.tds) || 0;
          });
          setTotals(ttt);
          setKpsTotal(kps);
        } else {
          setTableData([]);
          setKpsTotal({});
        }
      },
      onError: (data) => {
        setTableData([]);
        setKpsTotal({});
      },
    }
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    console.log(selectedStatus);
    setQuery({
      billDate: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
        $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      },
      vendor: branchOpt?.value || undefined,
      city: selectedCity?.value || undefined,
      head: selectedHead?.value || undefined,
      payStatus: selectedStatus?.value || undefined,
    });
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const { paymentPublicKey } = useAuthStore();
  const tableRef = useRef(null);

  const encryptWithRSA = async (data: object): Promise<string | false> => {
    if (!paymentPublicKey) return false;
    try {
      let pemBody = paymentPublicKey
        .replace(/-----BEGIN (RSA )?PUBLIC KEY-----/g, "")
        .replace(/-----END (RSA )?PUBLIC KEY-----/g, "")
        .replace(/\\n/g, "")
        .replace(/\s/g, "");

      const binaryDer = Uint8Array.from(atob(pemBody), (c) => c.charCodeAt(0));

      const cryptoKey = await crypto.subtle.importKey(
        "spki",
        binaryDer.buffer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"],
      );

      const encoded = new TextEncoder().encode(JSON.stringify(data));
      const encrypted = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);

      const bytes = new Uint8Array(encrypted);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    } catch (e) {
      console.error("RSA-OAEP encryption failed:", e);
      return false;
    }
  };

  const handleBulkPayment = async () => {
    if (!paymentPublicKey) {
      UseToast("Payment key not available. Please re-login.", "error");
      return;
    }
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row.", "error");
      return;
    }

    const selectedData = tableData.filter((row: any) => selectedRows.has(row.id));

    // Build HTML for editable amounts table
    let tableHtml = '<div style="max-height:300px;overflow-y:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;">';
    tableHtml += '<tr style="background:#f3f4f6;"><th style="padding:6px;border:1px solid #e5e7eb;">Vendor</th><th style="padding:6px;border:1px solid #e5e7eb;">Payable</th><th style="padding:6px;border:1px solid #e5e7eb;">Pay Amount</th></tr>';
    selectedData.forEach((r: any) => {
      const payable = ((Number(r.finalTotal) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0)).toFixed(2);
      tableHtml += `<tr><td style="padding:4px 6px;border:1px solid #e5e7eb;">${r._vendor?.vendor_name || '-'}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;text-align:right;">₹${payable}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;"><input type="number" id="amt_${r.id}" value="${payable}" max="${payable}" min="0" step="0.01" style="width:100px;padding:4px;border:1px solid #d1d5db;border-radius:4px;text-align:right;" /></td></tr>`;
    });
    tableHtml += '</table></div>';
    tableHtml += '<div style="margin-top:12px;"><label style="font-weight:600;font-size:13px;">Debit Account:</label><select id="swal_debitAccount" style="width:100%;padding:8px;border:1px solid #d1d5db;border-radius:6px;margin-top:4px;"><option value="">Select Branch</option><option value="1">Ahmedabad Branch</option><option value="2">Delhi Branch</option><option value="3">Mumbai Branch</option></select></div>';

    const { isConfirmed } = await Swal.fire({
      title: "Company Expense Bulk Payment",
      html: tableHtml,
      width: 550,
      showCancelButton: true,
      confirmButtonText: "Request OTP",
      preConfirm: () => {
        const debitAccount = (document.getElementById("swal_debitAccount") as HTMLSelectElement)?.value;
        if (!debitAccount) {
          Swal.showValidationMessage("Please select a branch");
          return false;
        }
        // Validate amounts
        for (const r of selectedData) {
          const maxPayable = (Number(r.finalTotal) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0);
          const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
          const amt = Number(input?.value);
          if (isNaN(amt) || amt <= 0) {
            Swal.showValidationMessage(`Invalid amount for ${r._vendor?.vendor_name}`);
            return false;
          }
          if (amt > maxPayable) {
            Swal.showValidationMessage(`Amount for ${r._vendor?.vendor_name} cannot exceed ₹${maxPayable.toFixed(2)}`);
            return false;
          }
        }
        return true;
      },
    });

    if (!isConfirmed) return;

    // Collect values after confirm
    const debitAccountKey = Number((document.getElementById("swal_debitAccount") as HTMLSelectElement)?.value);
    const ids: number[] = [];
    const amounts: Record<string, number> = {};
    selectedData.forEach((r: any) => {
      const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
      ids.push(r.id);
      amounts[String(r.id)] = Number(input?.value);
    });

    // Encrypt debitAccountKey + paymentType
    const encryptedPayload = await encryptWithRSA({ debitAccountKey, paymentType: "COMPANY_EXPENSE" });
    if (!encryptedPayload) {
      UseToast("Encryption failed. Please re-login.", "error");
      return;
    }

    try {
      const otpRes: any = await CreateCommanWay({
        url: "/admin/payment/request-otp",
        data: { ids, amounts, encryptedPayload },
      });

      if (otpRes?.status !== "SUCCESS") {
        UseToast(otpRes?.message || "Failed to request OTP", "error");
        return;
      }

      const requestId = otpRes?.data?.requestId;

      // Ask for OTP
      const { value: otp } = await Swal.fire({
        title: "Enter OTP",
        input: "text",
        inputPlaceholder: "Enter 6-digit OTP",
        showCancelButton: true,
        confirmButtonText: "Release Payment",
        inputValidator: (value) => {
          if (!value) return "Please enter OTP";
          if (value.length !== 6) return "OTP must be 6 digits";
        },
      });

      if (!otp) return;

      // Encrypt OTP payload and call release
      const encryptedRelease = await encryptWithRSA({ requestId, otp });
      if (!encryptedRelease) {
        UseToast("Encryption failed.", "error");
        return;
      }

      const releaseRes: any = await CreateCommanWay({
        url: "/admin/payment/release",
        data: { payload: encryptedRelease },
      });

      if (releaseRes?.status === "SUCCESS") {
        UseToast("Payment released successfully!", "success");
        setSelectedRows(new Set());
        refetch();
      } else {
        UseToast(releaseRes?.message || "Payment release failed", "error");
      }
    } catch (err: any) {
      UseToast(typeof err === "string" ? err : err?.message || "Something went wrong", "error");
    }
  };

  // Payment Advice - frontend only HTML generation
  const handlePaymentAdvice = () => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one payment", "error");
      return;
    }

    const selectedData = tableData.filter((row: any) => selectedRows.has(row.id));

    // Check if all selected belong to the same vendor
    const vendorIds = new Set(selectedData.map((r: any) => r.vendor));
    if (vendorIds.size > 1) {
      UseToast("Payment Advice can only be generated for a single vendor. Selected payments belong to multiple vendors.", "error");
      return;
    }

    const vendorName = selectedData[0]?._vendor?.vendor_name || "-";
    const vendorGst = selectedData[0]?._vendor?.gstno_client_supplier || "-";
    let vendorAddress = selectedData[0]?._vendor?.office_address || selectedData[0]?._vendor?.address || "-";
    if (vendorAddress !== "-" && selectedData[0]?._vendor?.pin_code && !vendorAddress.includes(selectedData[0]?._vendor?.pin_code)) {
      vendorAddress += ` - ${selectedData[0]?._vendor?.pin_code}`;
    }
    const rawAccountNo = (selectedData[0]?._vendor?.account_no || selectedData[0]?._vendor?.bankAccNo || selectedData[0]?._vendor?.bank_acc_no || "").trim();
    const maskedBankAcc = rawAccountNo ? (rawAccountNo.length > 4 ? `**** *** ${rawAccountNo.slice(-4)}` : rawAccountNo) : "-";
    const vendorIfsc = selectedData[0]?._vendor?.ifsc || selectedData[0]?._vendor?.bankIfsc || selectedData[0]?._vendor?.bank_ifsc || "-";
    const companyGst = selectedData[0]?.company_gst_no || selectedData[0]?._vendor?.company_gst_no || "24AALCA0600L1Z0";

    const parseTransactions = (txns: any) => {
      if (!txns) return [];
      let parsed = txns;
      if (typeof parsed === "string") {
        try {
          while (typeof parsed === "string") parsed = JSON.parse(parsed);
        } catch {
          return [];
        }
      }
      return Array.isArray(parsed) ? parsed : [];
    };

    const isStatusProcessed = (st: any, ref?: any) => {
      const s = String(st || "").trim().toUpperCase();
      const r = String(ref || "").trim().toUpperCase();
      return s === "PROCESSED" || s === "PROCESS" || r === "PROCESS" || r === "PROCESSED";
    };

    const getSlipStatus = (st: any, ref?: any) => {
      if (isStatusProcessed(st, ref)) {
        return "PROCESSED";
      }
      return st || "-";
    };

    // Calculate totals (strictly per bill to avoid duplicate summing)
    let totalBasic = 0, totalCgst = 0, totalSgst = 0, totalIgst = 0, totalInvoice = 0, totalTds = 0, totalPayable = 0, totalPaid = 0, totalRemaining = 0;
    selectedData.forEach((r: any) => {
      const basic = Number(r.amount) || 0;
      const cgst = Number(r.cgst) || 0;
      const sgst = Number(r.sgst) || 0;
      const igst = Number(r.igst) || 0;
      const finalAmt = Number(r.finalTotal) || 0;
      const tds = Number(r.tds) || 0;
      const payable = finalAmt - tds;

      const txns = parseTransactions(r.transactions);
      const isProcessed = isStatusProcessed(r.payStatus, r.refNo);
      let paid = 0;
      if (txns.length > 0) {
        paid = txns.reduce((sum: number, t: any) => sum + (Number(t.amount) || 0), 0);
      } else {
        paid = Number(r.totalPaid) || 0;
        if (paid === 0 && isProcessed) {
          paid = payable;
        }
      }
      const remaining = Math.max(0, payable - paid);

      totalBasic += basic;
      totalCgst += cgst;
      totalSgst += sgst;
      totalIgst += igst;
      totalInvoice += finalAmt;
      totalTds += tds;
      totalPayable += payable;
      totalPaid += paid;
      totalRemaining += remaining;
    });

    const adviceDate = moment().format("DD/MM/YYYY");

    let srNo = 1;
    const tableRowsHtml = selectedData.map((r: any) => {
      const txns = parseTransactions(r.transactions);
      const billDateStr = r.billDate && r.billDate != "Invalid Date" ? moment(r.billDate).format("DD/MM/YYYY") : "-";
      const basicAmt = (Number(r.amount) || 0).toFixed(2);
      const cgstAmt = (Number(r.cgst) || 0).toFixed(2);
      const sgstAmt = (Number(r.sgst) || 0).toFixed(2);
      const igstAmt = (Number(r.igst) || 0).toFixed(2);
      const finalAmt = (Number(r.finalTotal) || 0).toFixed(2);
      const tdsAmt = (Number(r.tds) || 0).toFixed(2);
      const payableAmt = ((Number(r.finalTotal) || 0) - (Number(r.tds) || 0)).toFixed(2);
      const isRowProcessed = isStatusProcessed(r.payStatus, r.refNo);

      let rowPaidAmt = Number(r.totalPaid) || 0;
      if (rowPaidAmt === 0 && isRowProcessed && txns.length === 0) {
        rowPaidAmt = Number(payableAmt) || 0;
      }
      const remainingAmt = Math.max(
        0,
        (Number(payableAmt) || 0) - (txns.length > 0 ? txns.reduce((s: number, t: any) => s + (Number(t.amount) || 0), 0) : rowPaidAmt)
      ).toFixed(2);

      if (txns.length === 0) {
        const payDateStr = r.payDate && r.payDate != "Invalid Date" ? moment(r.payDate).format("DD/MM/YYYY") : '-';
        return `
        <tr>
          <td class="text-center">${srNo++}</td>
          <td class="text-center">${r.head || '-'}</td>
          <td class="text-center">${billDateStr}</td>
          <td class="text-right">${basicAmt}</td>
          <td class="text-right">${cgstAmt}</td>
          <td class="text-right">${sgstAmt}</td>
          <td class="text-right">${igstAmt}</td>
          <td class="text-right">${finalAmt}</td>
          <td class="text-right">${tdsAmt}</td>
          <td class="text-right">${payableAmt}</td>
          <td class="text-right">${rowPaidAmt.toFixed(2)}</td>
          <td class="text-right">${remainingAmt}</td>
          <td class="text-center">${getSlipStatus(r.payStatus, r.refNo)}</td>
          <td class="text-center">${r.batchNo || r.batch_no || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }

      if (txns.length === 1) {
        const t = txns[0];
        const tDate = t.date || r.payDate;
        const payDateStr = tDate && tDate !== "Invalid Date"
          ? moment(tDate, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD", "DD-MM-YYYY"]).format("DD/MM/YYYY")
          : '-';
        let singlePaid = Number(t.amount !== undefined ? t.amount : r.totalPaid) || 0;
        if (singlePaid === 0 && (isStatusProcessed(t.status) || isRowProcessed)) {
          singlePaid = Number(payableAmt) || 0;
        }
        const paidAmt = singlePaid.toFixed(2);
        const singleRemaining = Math.max(0, (Number(payableAmt) || 0) - singlePaid).toFixed(2);
        return `
        <tr>
          <td class="text-center">${srNo++}</td>
          <td class="text-center">${r.head || '-'}</td>
          <td class="text-center">${billDateStr}</td>
          <td class="text-right">${basicAmt}</td>
          <td class="text-right">${cgstAmt}</td>
          <td class="text-right">${sgstAmt}</td>
          <td class="text-right">${igstAmt}</td>
          <td class="text-right">${finalAmt}</td>
          <td class="text-right">${tdsAmt}</td>
          <td class="text-right">${payableAmt}</td>
          <td class="text-right">${paidAmt}</td>
          <td class="text-right">${singleRemaining}</td>
          <td class="text-center">${getSlipStatus(t.status || r.payStatus, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }

      // Multiple transactions: Use rowspan for bill-level columns so amounts appear once
      const rowSpan = txns.length;
      return txns.map((t: any, idx: number) => {
        const tDate = t.date || r.payDate;
        const payDateStr = tDate && tDate !== "Invalid Date"
          ? moment(tDate, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD", "DD-MM-YYYY"]).format("DD/MM/YYYY")
          : '-';
        const paidAmt = (Number(t.amount) || 0).toFixed(2);

        if (idx === 0) {
          return `
        <tr>
          <td rowspan="${rowSpan}" class="text-center">${srNo++}</td>
          <td rowspan="${rowSpan}" class="text-center">${r.head || '-'}</td>
          <td rowspan="${rowSpan}" class="text-center">${billDateStr}</td>
          <td rowspan="${rowSpan}" class="text-right">${basicAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${cgstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${sgstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${igstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${finalAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${tdsAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${payableAmt}</td>
          <td class="text-right">${paidAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${remainingAmt}</td>
          <td class="text-center">${getSlipStatus(t.status || r.payStatus, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
        }

        return `
        <tr>
          <td class="text-right">${paidAmt}</td>
          <td class="text-center">${getSlipStatus(t.status || r.payStatus, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }).join('');
    }).join('');

    const html = `
<!DOCTYPE html>
<html>
<head>
  <title>Payment Advice - ${vendorName}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #333; }
    .container { max-width: 1100px; margin: 0 auto; border: 2px solid #333; padding: 30px; }
    .header { display: flex; align-items: center; border-bottom: 2px solid #333; padding-bottom: 15px; margin-bottom: 20px; position: relative; }
    .header img { height: 50px; position: absolute; left: 0; }
    .header .header-text { flex: 1; text-align: center; }
    .header h1 { font-size: 22px; font-weight: bold; color: #1a1a1a; }
    .header h2 { font-size: 16px; color: #555; margin-top: 5px; }
    .title { text-align: center; font-size: 18px; font-weight: bold; margin: 15px 0; text-decoration: underline; }
    .info-section { display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 13px; }
    .info-section .left, .info-section .right { width: 48%; }
    .info-section p { margin: 4px 0; }
    .info-section .label { font-weight: 600; display: inline-block; min-width: 100px; }
    table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 11px; }
    th { background: #f0f0f0; border: 1px solid #333; padding: 5px 6px; text-align: center; font-weight: 600; }
    td { border: 1px solid #333; padding: 4px 6px; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .total-row { font-weight: bold; background: #f9f9f9; }
    .footer { margin-top: 20px; display: flex; justify-content: space-between; align-items: flex-end; font-size: 11px; }
    .footer .note-block { color: #666; max-width: 350px; }
    .footer .note-block p { margin: 3px 0; }
    .footer .sign-block { text-align: center; display: flex; flex-direction: column; align-items: center; }
    .footer .sign-block .images { display: flex; align-items: center; gap: 5px; }
    .footer .sign-block .stamp { height: 70px; }
    .footer .sign-block .sign { height: 45px; }
    .footer .sign-block .line { border-top: 1px solid #333; padding-top: 5px; margin-top: 5px; width: 100%; }
    .note { margin-top: 20px; font-size: 11px; color: #666; border-top: 1px dashed #999; padding-top: 10px; }
    @media print {
      body { padding: 10px; }
      .container { border: none; padding: 10px; }
      .no-print { display: none; }
    }
    .print-btn { text-align: center; margin-bottom: 20px; display: flex; gap: 10px; justify-content: center; }
    .print-btn button { padding: 10px 30px; font-size: 14px; background: #2563eb; color: white; border: none; border-radius: 5px; cursor: pointer; }
    .print-btn button:hover { background: #1d4ed8; }
    .print-btn button.pdf-btn { background: #dc2626; }
    .print-btn button.pdf-btn:hover { background: #b91c1c; }
    .amount-words { font-size: 13px; margin: 10px 0; font-style: italic; }
  </style>
</head>
<body>
  <div class="print-btn no-print">
    <button onclick="window.print()">Print Payment Advice</button>
    <button class="pdf-btn" onclick="downloadPdf()">Download PDF</button>
  </div>
  <div class="container">
    <div class="header">
      <img src="/logo.jpg" alt="Airfield Express" />
      <div class="header-text">
        <h1>AIRFIELD EXPRESS PRIVATE LIMITED</h1>
        <h2>Payment Advice (Company Expense)</h2>
      </div>
    </div>

    <div class="info-section">
      <div class="left">
        <p><span class="label">To:</span> ${vendorName}</p>
        <p><span class="label">GSTIN:</span> ${vendorGst}</p>
        <p><span class="label">Address:</span> ${vendorAddress}</p>
        <p><span class="label">Bank Acc No:</span> ${maskedBankAcc}</p>
        <p><span class="label">IFSC Code:</span> ${vendorIfsc}</p>
      </div>
      <div class="right" style="text-align: right;">
        <p><span class="label">Date:</span> ${adviceDate}</p>
        <p><span class="label">No. of Bills:</span> ${selectedData.length}</p>
        <p><span class="label">CIN:</span> U64120DL2012PTC243510</p>
        <p><span class="label">GSTIN:</span> ${companyGst}</p>
      </div>
    </div>

    <div class="title">PAYMENT ADVICE</div>

    <table>
      <thead>
        <tr>
          <th>Sr.</th>
          <th>Head</th>
          <th>Bill Date</th>
          <th>Basic Amt (₹)</th>
          <th>CGST (₹)</th>
          <th>SGST (₹)</th>
          <th>IGST (₹)</th>
          <th>Invoice Amt (₹)</th>
          <th>TDS (₹)</th>
          <th>Payable (₹)</th>
          <th>Paid (₹)</th>
          <th>Remaining (₹)</th>
          <th>Status</th>
          <th>Batch no</th>
          <th>Pay Date</th>
        </tr>
      </thead>
      <tbody>
        ${tableRowsHtml}
        <tr class="total-row">
          <td colspan="3" class="text-center">TOTAL</td>
          <td class="text-right">${totalBasic.toFixed(2)}</td>
          <td class="text-right">${totalCgst.toFixed(2)}</td>
          <td class="text-right">${totalSgst.toFixed(2)}</td>
          <td class="text-right">${totalIgst.toFixed(2)}</td>
          <td class="text-right">${totalInvoice.toFixed(2)}</td>
          <td class="text-right">${totalTds.toFixed(2)}</td>
          <td class="text-right">${totalPayable.toFixed(2)}</td>
          <td class="text-right">${totalPaid.toFixed(2)}</td>
          <td class="text-right">${totalRemaining.toFixed(2)}</td>
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>

    <p class="amount-words"><strong>Total Payable: ₹ ${totalPayable.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} | Paid: ₹ ${totalPaid.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} | Remaining: ₹ ${totalRemaining.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></p>

    <div class="footer">
      <div class="note-block">
        <p>This is a system-generated Payment Advice.</p>
        <p>For any discrepancies, please contact accounts department immediately. Email: purchase@airfield.co.in</p>
      </div>
      <div class="sign-block">
        <div class="images">
          <img class="stamp" src="/images/stamp1.png" alt="Company Stamp" />
          <img class="sign" src="/images/sanjiv_sign.png" alt="Signature" />
        </div>
        <div class="line">Authorized Signatory</div>
      </div>
    </div>
  </div>
  <script>
    function downloadPdf() {
      var el = document.querySelector('.container');
      var opt = {
        margin: 10,
        filename: 'Payment_Advice_${vendorName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
      };
      html2pdf().set(opt).from(el).save();
    }
  </script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
</body>
</html>`;

    // Open in new window
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(html);
      newWindow.document.close();
    }
  };

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Company Expense Report.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {rejectModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Reject Remark</label>
                <input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-52 p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    updatePayMutate({
                      url: "/admin/companyexpense/update/" + seletedPayment?.id,
                      data: {
                        status: "REJECTED",
                        remark: remark,
                      },
                    });
                  }}
                >
                  Reject
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setRejectModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {disburseModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-full">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col gap-4 bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 w-full max-w-sm">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">
                  Payment Date: {seletedPayment.payDate ? moment(seletedPayment.payDate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "-"}
                </label>
                {/*<input
                  type="date"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  value={payDate}
                  onChange={(e) => setpayDate(e.target.value)}
                  disabled={true}
                />*/}
              </div>

              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font- text-gray-900">Payment Method: {seletedPayment.payType}</label>
                {/*<Select
                  className={`${false ? "bg-gray-300" : ""} w-full bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={GenericColumnData?.companyexpense?.tableColumnData?.find((d: any) => d.key === "payType")?.options || []}
                  onChange={(e) => {
                    setPayType(e);
                  }}
                  value={payType}
                  isClearable={true}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Payment Ref. No: {seletedPayment.refNo}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Payment Ref. No"
                  value={refNo}
                  onChange={(e) => setRefNo(e.target.value)}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark: {seletedPayment.remark}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />*/}
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    /*if (!payDate || !refNo || !payType?.value) {
                      window.alert("Select Valid Value");
                      return;
                    }*/
                    updatePayMutate({
                      url: "/admin/companyexpense/update/" + seletedPayment?.id,
                      data: {
                        status: "PAID",
                        /*payDate: payDate,
                        payType: payType?.value || "",
                        refNo: refNo || "",
                        remark: remark || "",*/
                      },
                    });
                  }}
                >
                  Disburse
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setDisburseModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* GST/TDS Paid Confirmation Modal */}
      {gstTdsPaidModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[300px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                {isPaidAction ? "Mark" : "Unmark"} {paidType === "gst" ? "GST" : "TDS"} as {isPaidAction ? "Paid" : "Unpaid"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${isPaidAction ? "text-green-600" : "text-red-600"}`}>
                  Total {paidType === "gst" ? "GST" : "TDS"}: ₹{" "}
                  {getSelectedTotal(paidType!).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${isPaidAction ? "bg-green-500 hover:bg-green-600 focus:ring-green-700" : "bg-red-500 hover:bg-red-600 focus:ring-red-700"}`}
                  onClick={handleConfirmPaid}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : "Confirm"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setGstTdsPaidModalOpen(false);
                    setPaidType(null);
                    setIsPaidAction(true);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Disburse/Reject Confirmation Modal */}
      {bulkActionModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[350px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                Bulk {bulkActionType === "disburse" ? "Disburse" : "Reject"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${bulkActionType === "disburse" ? "text-green-600" : "text-red-600"}`}>
                  Total Payable: ₹{" "}
                  {tableData
                    .filter((row: any) => selectedRows.has(row.id))
                    .reduce((sum: number, row: any) => sum + (Number(row.finalTotal || 0) - Number(row.tds || 0)), 0)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </div>
              {bulkActionType === "reject" && (
                <div className="mb-4">
                  <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Reject Remark"
                    value={bulkRemark}
                    onChange={(e) => setBulkRemark(e.target.value)}
                  />
                </div>
              )}
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${
                    bulkActionType === "disburse"
                      ? "bg-green-500 hover:bg-green-600 focus:ring-green-700"
                      : "bg-red-500 hover:bg-red-600 focus:ring-red-700"
                  }`}
                  onClick={handleConfirmBulkAction}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : bulkActionType === "disburse" ? "Confirm Disburse" : "Confirm Reject"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setBulkActionModalOpen(false);
                    setBulkActionType(null);
                    setBulkRemark("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="flex items-center justify-between px-4 mb-0 mt-1">
        {/* Left: GST & TDS Paid Buttons */}
        <div className="flex gap-2">
          <button
            onClick={() => handlePaidClick("gst", true)}
            type="button"
            className="bg-purple-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Paid
          </button>
          <button
            onClick={() => handlePaidClick("gst", false)}
            type="button"
            className="bg-purple-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Unpaid
          </button>
          <button
            onClick={() => handlePaidClick("tds", true)}
            type="button"
            className="bg-orange-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Paid
          </button>
          <button
            onClick={() => handlePaidClick("tds", false)}
            type="button"
            className="bg-orange-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Unpaid
          </button>
        </div>

        {/* Center: Title & Add New Button */}
        <div className="flex items-center gap-4">
          <h1 className="text-lg font-semibold">Company Expense</h1>
          <button
            onClick={() => {
              //setAddModalOpen(true);
              navigator("/master/companyexpense/add");
            }}
            type="button"
            className="bg-green-700 text-white px-4 py-1 rounded-md"
          >
            Add New
          </button>
        </div>

        {/* Right: Export Buttons */}
        <div className="flex gap-2">
          <button onClick={exportToExcel} className="bg-blue-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-700">
            Excel Export
          </button>
        </div>
      </div>

      <div className="px-4 border-[1px] py-2 mx-4 mt-1 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-2 gap-y-2">
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Vendor</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={branchOptions}
                onChange={(e) => {
                  setBranchOtp(e);
                }}
                value={branchOpt}
                isClearable={true}
              />
            </div>
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">City</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={cityOptions}
                onChange={(e) => {
                  setSelectedCity(e);
                }}
                value={selectedCity}
                isClearable={true}
              />
            </div>

            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Status</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-40 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={GenericColumnData?.companyexpense?.tableColumnData?.find((d: any) => d.key === "payStatus")?.options || []}
                onChange={(e) => {
                  setSelectedStatus(e);
                }}
                value={selectedStatus}
                isClearable={true}
              />
            </div>

            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Head</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={expenseHeadOptions}
                onChange={(e) => {
                  setSelectedHead(e);
                }}
                value={selectedHead}
                isClearable={true}
              />
            </div>

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className="px-4 border-[1px] py-2 mx-4 my-1 rounded-md text-center flex items-center justify-center gap-2 flex-wrap">
        {selectedRows.size > 0 &&
          !tableData.some(
            (row: any) => selectedRows.has(row.id) && ["PAID", "REJECTED", "PENDING"].includes(row.payStatus),
          ) && (
            <div className="inline-flex gap-2 flex-col mr-8">
              <Button
                onPress={() => handleBulkAction("disburse")}
                color="success"
                size="sm"
              >
                Bulk Disburse ({selectedRows.size})
              </Button>
              <Button
                onPress={() => handleBulkAction("reject")}
                color="danger"
                size="sm"
              >
                Bulk Reject ({selectedRows.size})
              </Button>
              {userDetails.roleName == roles.SUPER_ADMIN && paymentPublicKey && (
                <Button
                  onPress={handleBulkPayment}
                  color="warning"
                  size="sm"
                  className="text-white"
                >
                  Bulk Payment ({selectedRows.size})
                </Button>
              )}
            </div>
          )}
        {selectedRows.size > 0 && (
          <div className="inline-flex gap-2 flex-col mr-8">
            <Button
              onPress={handlePaymentAdvice}
              color="primary"
              size="sm"
            >
              Payment Advice ({selectedRows.size})
            </Button>
          </div>
        )}
        {Object.keys(kpsTotal).map((kpsKeys) => {
          return (
            <div
              key={kpsKeys + "-kps"}
              className={`border-2 rounded-md p-2 inline-block ${kpsKeys == "PENDING" ? "bg-yellow-200" : ""} ${
                kpsKeys == "VERIFIED" ? "bg-purple-200" : ""
              } ${kpsKeys == "PAID" ? "bg-green-300" : ""}`}
            >
              <p className="font-semibold">
                {kpsKeys || "-"} ({kpsTotal[kpsKeys][0]})
              </p>
              <p className="text-2xl">
                {"₹ " +
                  (Number(kpsTotal[kpsKeys][1]) || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </p>
            </div>
          );
        })}
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{tableData?.length}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1" colSpan={6}>
                {selectedRows.size > 0 && (
                  <span className="text-primary font-inter">
                    Selected Payable: ₹{" "}
                    {tableData
                      .filter((row: any) => selectedRows.has(row.id))
                      .reduce((sum: number, row: any) => sum + (Number(row.finalTotal || 0) - Number(row.tds || 0)), 0)
                      .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    {" "}({selectedRows.size} rows)
                  </span>
                )}
              </th>
              <th className="border border-slate-200 px-1 py-2">{totals.base?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.cgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.sgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.igst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.tds).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.payable).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.totalPaid).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.remaining).toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1">
                <input
                  type="checkbox"
                  checked={tableData?.length > 0 && selectedRows.size === tableData?.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="w-4 h-4 cursor-pointer"
                />
              </th>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Action</th>
              <th className="border border-slate-200 px-1">Vendor</th>
              <th className="border border-slate-200 px-1">Head</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Expense Date {GET_SORT_ICON("billDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Pay Date {GET_SORT_ICON("payDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">From Date {GET_SORT_ICON("fromDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">To Date {GET_SORT_ICON("toDate", "")}</th>
              <th className="border border-slate-200 px-1">Basic Amt</th>
              <th className="border border-slate-200 px-1">cgst</th>
              <th className="border border-slate-200 px-1">sgst</th>
              <th className="border border-slate-200 px-1">igst</th>
              <th className="border border-slate-200 px-1">Invoice Amt</th>
              <th className="border border-slate-200 px-1">tds</th>
              <th className="border border-slate-200 px-1">Payable Amt</th>
              <th className="border border-slate-200 px-1">Total Paid</th>
              <th className="border border-slate-200 px-1">Remaining</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Status {GET_SORT_ICON("Status", "asc")}</th>
              <th className="border border-slate-200 px-1">Ref No</th>
              <th className="border border-slate-200 px-1">GST Paid</th>
              <th className="border border-slate-200 px-1">TDS Paid</th>
              <th className="border border-slate-200 px-1">Remark</th>
              <th className="border border-slate-200 px-1">Remark2</th>
              <th className="border border-slate-200 px-1">-</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr
                    key={"r" + r.id}
                    className={`${
                      r.refNo == "PROCESS"
                        ? "bg-orange-300"
                        : r.payStatus == "PAID"
                          ? "bg-green-300"
                          : r.payStatus == "REJECTED"
                            ? "bg-red-300"
                            : r.payStatus == "PENDING"
                              ? "bg-yellow-200"
                              : r.payStatus == "VERIFIED"
                                ? "bg-purple-200"
                                : ""
                    }`}
                  >
                    <td className="border border-slate-200 px-2">
                      <input
                        type="checkbox"
                        checked={selectedRows.has(r.id)}
                        onChange={(e) => handleRowSelect(r.id, e.target.checked)}
                        className="w-4 h-4 cursor-pointer"
                      />
                    </td>
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">
                      {userDetails.roleName != roles.SUPER_ADMIN && !["PAID", "REJECTED", "VERIFIED"].includes(r.payStatus) && (
                        <button
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure!",
                              html: `${r._vendor?.vendor_name || "-"}<br>Amount:${r.finalTotal}`,
                              icon: "question",
                              confirmButtonText: "Verify Expense",
                              showCancelButton: true,
                            }).then((x) => {
                              if (x.isConfirmed) {
                                updatePayMutate({
                                  url: "/admin/companyexpense/update/" + r?.id,
                                  data: {
                                    payStatus: "VERIFIED",
                                  },
                                });
                              }
                            });
                          }}
                          className="text-white bg-purple-800 px-2 py-1 rounded-md mt-1"
                        >
                          Verify
                        </button>
                      )}
                      {userDetails.roleName == roles.SUPER_ADMIN && !["PAID", "REJECTED", "PENDING"].includes(r.payStatus) && (
                        <button
                          onClick={() => {
                            setDisburseModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-green-600 px-1 py-0.5 text-sm rounded-md"
                        >
                          Disburse
                        </button>
                      )}
                      {!["PAID", "REJECTED"].includes(r.payStatus) && (
                        <button
                          onClick={() => {
                            setRejectModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-red-600 px-2 py-1 rounded-md mt-1"
                        >
                          Reject
                        </button>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2">{r._vendor?.vendor_name}</td>
                    <td className="border border-slate-200 px-2">{r.head}</td>
                    <td className="border border-slate-200 px-2">
                      {r.billDate && r.billDate != "Invalid Date" ? moment(r.billDate).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      {r.payDate && r.payDate != "Invalid Date" ? moment(r.payDate).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      {r.fromDate && r.fromDate != "Invalid date" ? moment(r.fromDate).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      {r.toDate && r.toDate != "Invalid date" ? moment(r.toDate).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2 text-right">{r.amount}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.cgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.sgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.igst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.finalTotal}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.tds}</td>
                    <td className="border border-slate-200 px-2 text-right">{(Number(r.finalTotal || 0) - Number(r.tds || 0)).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 text-right">{Number(r.totalPaid || 0).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 text-right">{((Number(r.finalTotal) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0)).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r.payStatus}</td>
                    <td className="border border-slate-200 px-2">{r.refNo}</td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${r.gstPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {r.gstPaid ? "Yes" : "No"}
                    </td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${r.tdsPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {r.tdsPaid ? "Yes" : "No"}
                    </td>
                    <td className="border border-slate-200 px-2">{r.remark}</td>
                    <td className="border border-slate-200 px-2">{r.remark2}</td>
                    <td className="border border-slate-200 px-2">
                      <button
                        onClick={() => {
                          //navigator(`/master/companyexpense/list/${r.id}`);
                          window.open(`/master/companyexpense/list/${r.id}`, "_blank");
                        }}
                        className="text-blue-500"
                      >
                        View
                      </button>
                      <br />
                      <button
                        onClick={() => {
                          let confirm_ = window.confirm("Are you sure");
                          if (confirm_) {
                            deleteCompanyExpense(r.id);
                          }
                          //navigator(`/master/companyexpense/list/${r.id}`);
                        }}
                        className="text-red-500"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CompanyExpensesList;
